import { FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';

function Footer() {
  const openWhatsApp = () => {
    const phoneNumber = "+919698704907";
    const message = encodeURIComponent(
      "Hello! I would like to book an appointment."
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <footer
      style={{
        backgroundColor: "#00246B", // Dark blue background
        color: "#CADCFC", // Light blue text
        fontFamily: "'Roboto', sans-serif",
        fontSize: "15px", // Updated font size
        padding: "50px 20px 30px",
        textAlign: "center",
        borderTop: "5px solid #3498db", // Accent border (remains as blue accent)
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "40px",
        }}
      >
        {/* Contact Section */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "40px",
            paddingBottom: "30px",
            borderBottom: "1px solid #3498db", // Stylish line separating sections
          }}
        >
          <div style={{ flex: "1 1 40%", maxWidth: "500px" }}>
            <h4
              style={{
                fontSize: "20px",
                color: "#CADCFC", // Light blue for headings
                fontWeight: "600",
                marginBottom: "10px",
              }}
            >
              Contact Us
            </h4>
            <p style={{ fontSize: "15px", margin: "10px 0" }}>
              30, Pariyur Rd, near mettuvalavu, opp. to sakthi sugar office,
              bustop, Gobichettipalayam, Tamil Nadu 638476
            </p>
            <p style={{ fontSize: "15px", margin: "10px 0" }}>
              <strong>Phone:</strong> 09698704907
            </p>
            <p style={{ fontSize: "15px", margin: "10px 0" }}>
              <strong>Landmark:</strong> Opp Sakthi Sugars Office
            </p>
            <p style={{ fontSize: "15px", margin: "10px 0" }}>
              <strong>Working Hours:</strong>
              <br />
              Mon - Sat: 10:30 am - 7:30 pm <br />
              Sunday by appointment only.
            </p>
          </div>

          <div style={{ flex: "1 1 40%", maxWidth: "500px" }}>
            <h4
              style={{
                fontSize: "20px",
                color: "#CADCFC", // Light blue for headings
                fontWeight: "600",
                marginBottom: "10px",
              }}
            >
              Find Us On
            </h4>
            <p style={{ fontSize: "15px", marginBottom: "20px" }}>
              Connect with us on social media for updates and more.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginTop: "20px",
              }}
            >
              <a
                href="https://www.instagram.com/dentin_gobichettipalayam?igsh=c2RmcmZieWhmcjFi&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div
                  style={{
                    backgroundColor: "#E1306C",
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1)",
                    transition: "transform 0.3s ease-in-out",
                  }}
                  className="social-icon"
                >
                  <FaInstagram size={24} color="#fff" />
                </div>
              </a>
              <a
                href="https://www.facebook.com/dentingobi/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div
                  style={{
                    backgroundColor: "#1877F2",
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1)",
                    transition: "transform 0.3s ease-in-out",
                  }}
                  className="social-icon"
                >
                  <FaFacebookF size={24} color="#fff" />
                </div>
              </a>
              <div
                onClick={openWhatsApp}
                style={{
                  backgroundColor: "#25D366",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease-in-out",
                }}
                className="social-icon"
              >
                <FaWhatsapp size={24} color="#fff" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div style={{ fontSize: "15px", fontFamily: "'Heebo', sans-serif" }}>
          &copy; {new Date().getFullYear()} Dentin Dental Care. All Rights
          Reserved.
        </div>
      </div>

      {/* Mobile Responsiveness */}
      <style>
        {`
          @media (max-width: 768px) {
            footer {
              padding: 30px 10px;
            }
            .footer-container {
              flex-direction: column;
            }
            .footer-container > div {
              flex: 1 1 100%;
              padding: 10px;
            }
            .footer-container iframe {
              height: 250px;
            }
            .footer-socials {
              flex-direction: column;
              gap: 10px;
            }
            .footer-socials > div {
              margin-bottom: 10px;
            }
            .footer-container > div {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
          }

          .social-icon:hover {
            transform: scale(1.1);
          }
        `}
      </style>
    </footer>
  );
}

export default Footer;